import React, { useEffect } from 'react';
import { SplitPane } from './SplitPane';
import { ChatInterface } from './ChatInterface';
import { StorybookEmbed } from './StorybookEmbed';
import { AgentProvider } from '../providers';
import { useAgentStore, useChatState, useUIState } from '../state/agent-store';
import { useAgentOperations } from '../hooks';

export interface AgentUIProps {
  storybookUrl?: string;
  projectPath?: string;
  className?: string;
}

// Internal component that uses hooks
const AgentUIContent: React.FC<AgentUIProps> = ({
  storybookUrl = 'http://localhost:6006',
  projectPath = process.cwd(),
  className = ''
}) => {
  const { initializeAgent } = useAgentStore();
  const { messages, isProcessing } = useChatState();
  const { selectedStory, setSelectedStory, splitPanePosition } = useUIState();
  const { processUserInput } = useAgentOperations();

  // Initialize agent
  useEffect(() => {
    initializeAgent(projectPath);
  }, [projectPath, initializeAgent]);

  return (
    <div className={`h-screen bg-gray-100 ${className}`}>
      <SplitPane
        left={
          <StorybookEmbed 
            storybookUrl={storybookUrl}
            selectedStory={selectedStory}
            onStoryChange={setSelectedStory}
          />
        }
        right={
          <ChatInterface
            messages={messages}
            onSendMessage={processUserInput}
            isProcessing={isProcessing}
            placeholder="Describe what you'd like to build or modify..."
          />
        }
        defaultSplit={splitPanePosition}
        minSize={300}
      />
    </div>
  );
};

// Main component with provider wrapper
export const AgentUI: React.FC<AgentUIProps> = (props) => {
  return (
    <AgentProvider>
      <AgentUIContent {...props} />
    </AgentProvider>
  );
};